import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import { useMutation } from 'react-query';

export const withdrawFromWallet = ({ data }) => {
  return axios.post(`/transaction/addWithdraw`, data);
};

export const useWithdrawFromWallet = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onMutate: async (newWithdrawal) => {},
    onError: (_, __, context) => {},
    onSuccess: (data) => {},
    ...config,
    mutationFn: withdrawFromWallet,
  });
};
